import Component from './EditLocation.container';

export default Component;
